<template>
  <b-row class="match-height">
    <b-col md="12">
      <b-card no-body>
        <b-card-body>
          <b-form-select
            v-model="url"
            :options="options"
            label-field="text"
            value-field="id"
            @input="change()"
          />
        </b-card-body>
      </b-card>
    </b-col>
    <b-col md="12">
      <chart-container ref="chart" />
    </b-col>
  </b-row>
</template>

<script>
import ChartContainer from "./ChartContainer.vue";

import ChartjsBarChart from "./ChartjsBarChart.vue";

export default {
  components: {
    ChartjsBarChart,
    ChartContainer,
  },
  data() {
    return {
      url: "",
      options: [
        { id: "generalReports", text: "تقارير عامة" },
        { id: "educationalActivityReports", text: "تقارير الأنشطة التعليمية" },
        {
          id: "coursesAndLecturesReports",
          text: "تقارير المقررات والمحاضرات المسجلة",
        },
        { id: "numericLibraryReports", text: "تقارير المكتبة الرقمية" },
        { id: "studentsReports", text: "تقارير الطلاب التفصيلية" },
        { id: "postgraduateReports", text: "تقارير الدراسات العليا المفصلة" },
        { id: "quranReports", text: "تقارير المقرأة الالكترونية المفصلة" },
      ],
    };
  },
  methods: {
    change() {
      const report = this.options.find(
        (option) => option.id === this.url
      );

      this.$refs.chart.setData(report);
    },
  },
};
</script>
